import React, { useContext } from "react";
import { HubContext } from "Redux/Context/context";
import { VegaGrid } from "@heartlandone/vega-react";
import Activity from "Views/MyActivity/ActivityItem/Index";

function FavoriteActivityList() {
  const { myActivitiesState } = useContext(HubContext);
  return (
    <VegaGrid row="2" column="3" gap="size-16">
      {myActivitiesState.activities?.map((activity, index) => {
        return <Activity key={index} activity={activity} />;
      })}
    </VegaGrid>
  );
}

export default FavoriteActivityList;
